export const PUBLIC_INTERVIEW_PROFILE_PATH = '/public/interview/:interviewId/:token';
export const PUBLIC_SCREENER_PROFILE_PATH = '/public/screener/:applicationId/:token';
export const LEGACY_SHARE_PROFILE_PATH = '/public/profile/:applicationId/:token';
